import { Component } from 'react';
import { Row } from 'react-bootstrap';
import Layout from './DashboardLayout';
import { InactiveTeamMember } from '../components/team';

class InactiveTeam extends Component {
  pageHeading = {
    preTitle: 'Team',
    title: `Inactive Team Member `,
  };

  constructor(props) {
    super(props);
    this.state = {
      isListView: false,
      pageHeading: this.pageHeading,
    };
  }

  componentDidUpdate() {}

  handleChangeView = () => {
    this.setState((state) => ({
      ...state,
      isListView: !state.isListView,
    }));
  };

  updateBreadCrumbTitle = (titlenew) => {
    this.setState((state) => ({
      ...state,
      pageHeading: {
        preTitle: 'Team',
        title: `Inactive Team Members ${titlenew} `,
      },
    }));
  };

  render() {
    const { isListView, pageHeading } = this.state;
    return (
      <Layout pageHeading={pageHeading}>
        <Row>
          <InactiveTeamMember
            isListView={isListView}
            updateBreadCrumbTitle={this.updateBreadCrumbTitle}
          />
        </Row>
      </Layout>
    );
  }
}

export default InactiveTeam;
